import {
	EVENT_ACTION_EDIT_VEHICLE,
	EVENT_CATEGORY_VEHICLE_MANAGEMENT,
	trackCustomEvent,
} from '../../../../shared/analytics';

export function trackEditVehicle() {
	trackCustomEvent({
		category: EVENT_CATEGORY_VEHICLE_MANAGEMENT,
		action: EVENT_ACTION_EDIT_VEHICLE,
	});
}
